import { initContract } from '@ts-rest/core';
const c = initContract();
export const tableViewContract = c.router({
    listTableViews: {
        method: 'GET',
        path: '/table-views',
        responses: {
            200: c.type(),
        },
    },
    // Static routes must come before parameterized routes
    getTemplates: {
        method: 'GET',
        path: '/table-views/templates',
        responses: {
            200: c.type(),
        },
    },
    useTemplate: {
        method: 'POST',
        path: '/table-views/use-template',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    registerTableViewFileOnly: {
        method: 'POST',
        path: '/table-views/files/register',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    listWorkspaceTableViewFiles: {
        method: 'GET',
        path: '/table-views/files',
        responses: {
            200: c.type(),
        },
    },
    listDatabaseSources: {
        method: 'GET',
        path: '/table-views/database-sources',
        responses: {
            200: c.type(),
        },
    },
    downloadPapers: {
        method: 'POST',
        path: '/table-views/download-papers',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    testDatabaseQuery: {
        method: 'POST',
        path: '/table-views/:id/database-query/test',
        body: c.type(),
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
    getTableView: {
        method: 'GET',
        path: '/table-views/:id',
        query: c.type(),
        responses: {
            200: c.type(),
        },
    },
    updateTableView: {
        method: 'PUT',
        path: '/table-views/:id',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    deleteTableView: {
        method: 'DELETE',
        path: '/table-views/:id',
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
    getPresignedUrls: {
        method: 'POST',
        path: '/table-views/:id/presigned-urls',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    registerFiles: {
        method: 'POST',
        path: '/table-views/:id/register-files',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    createTableView: {
        method: 'POST',
        path: '/table-views',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    generateTableViewColumns: {
        method: 'POST',
        path: '/table-views/:id/generate-columns',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    createTableViewColumn: {
        method: 'POST',
        path: '/table-views/columns',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    updateTableViewColumn: {
        method: 'PUT',
        path: '/table-views/columns/:columnId',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    deleteTableViewColumn: {
        method: 'DELETE',
        path: '/table-views/columns/:columnId',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    executeAnalysis: {
        method: 'POST',
        path: '/table-views/:id/execute-analysis',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    exportTableView: {
        method: 'GET',
        path: '/table-views/:id/export',
        responses: {
            200: c.type(),
        },
    },
    initializeFromProductCode: {
        method: 'POST',
        path: '/table-views/:id/initialize-from-product-code',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    deleteTableViewRows: {
        method: 'DELETE',
        path: '/table-views/:id/rows',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    createTableViewChat: {
        method: 'POST',
        path: '/table-views/:tableViewId/chat',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    getTableViewChat: {
        method: 'GET',
        path: '/table-views/:tableViewId/chat',
        responses: {
            200: c.type(),
        },
    },
    listLinkedFiles: {
        method: 'GET',
        path: '/table-views/:id/linked-files',
        responses: {
            200: c.type(),
        },
    },
    linkFiles: {
        method: 'POST',
        path: '/table-views/:id/link-files',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    unlinkFiles: {
        method: 'POST',
        path: '/table-views/:id/unlink-files',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    addDatabaseItems: {
        method: 'POST',
        path: '/table-views/:id/database-query/add',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    // Saved database query endpoints
    listDatabaseQueries: {
        method: 'GET',
        path: '/table-views/:id/database-queries',
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
    setDatabaseActive: {
        method: 'PATCH',
        path: '/table-views/:id/database-queries/active',
        body: c.type(),
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
    updateTableViewCell: {
        method: 'PATCH',
        path: '/table-views/:id/cell',
        body: c.type(),
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
    reorderTableViewColumns: {
        method: 'PUT',
        path: '/table-views/:id/columns/reorder',
        body: c.type(),
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
    regenerateCell: {
        method: 'POST',
        path: '/table-views/:id/regenerate-cell',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
            404: c.type(),
        },
    },
});
//# sourceMappingURL=tableView.js.map